export const VILLAGERS_DATA = {
  "Ace": { species: "Bird", gender: "male", personality: "Jock" },
  "Admiral": { species: "Bird", gender: "male", personality: "Cranky" },
  "Agent S": { species: "Squirrel", gender: "female", personality: "Peppy" },
  "Agnes": { species: "Pig", gender: "female", personality: "Uchi" },
  "Al": { species: "Gorilla", gender: "male", personality: "Lazy" },
  "Alfonso": { species: "Alligator", gender: "male", personality: "Lazy" },
  "Alice": { species: "Koala", gender: "female", personality: "Normal" },
  "Alli": { species: "Alligator", gender: "female", personality: "Snooty" },
  "Amelia": { species: "Eagle", gender: "female", personality: "Snooty" },
  "Anabelle": { species: "AntEater", gender: "female", personality: "Peppy" },
  "Anchovy": { species: "Bird", gender: "male", personality: "Lazy" },
  "Angus": { species: "Bull", gender: "male", personality: "Cranky" },
  "Anicotti": { species: "Mouse", gender: "female", personality: "Peppy" },
  "Ankha": { species: "Cat", gender: "female", personality: "Snooty" },
  "Annalisa": { species: "AntEater", gender: "female", personality: "Normal" },
  "Annalise": { species: "Horse", gender: "female", personality: "Snooty" },
  "Antonio": { species: "AntEater", gender: "male", personality: "Jock" },
  "Apollo": { species: "Eagle", gender: "male", personality: "Cranky" },
  "Apple": { species: "Hamster", gender: "female", personality: "Peppy" },
  "Astrid": { species: "Kangaroo", gender: "female", personality: "Snooty" },
  "Audie": { species: "Wolf", gender: "female", personality: "Peppy" },
  "Aurora": { species: "Penguin", gender: "female", personality: "Normal" },
  "Azalea": { species: "Rhino", gender: "female", personality: "Snooty" },
  "Ava": { species: "Chicken", gender: "female", personality: "Normal" },
  "Avery": { species: "Eagle", gender: "male", personality: "Cranky" },
  "Axel": { species: "Elephant", gender: "male", personality: "Jock" },
  "Baabara": { species: "Sheep", gender: "female", personality: "Snooty" },
  "Bam": { species: "Deer", gender: "male", personality: "Jock" },
  "Bangle": { species: "Tiger", gender: "female", personality: "Peppy" },
  "Barold": { species: "Cub", gender: "male", personality: "Lazy" },
  "Bea": { species: "Dog", gender: "female", personality: "Normal" },
  "Beardo": { species: "Bear", gender: "male", personality: "Smug" },
  "Beau": { species: "Deer", gender: "male", personality: "Lazy" },
  "Becky": { species: "Chicken", gender: "female", personality: "Snooty" },
  "Bella": { species: "Mouse", gender: "female", personality: "Peppy" },
  "Benedict": { species: "Chicken", gender: "male", personality: "Lazy" },
  "Benjamin": { species: "Dog", gender: "male", personality: "Lazy" },
  "Bertha": { species: "Hippo", gender: "female", personality: "Normal" },
  "Bettina": { species: "Mouse", gender: "female", personality: "Normal" },
  "Bianca": { species: "Tiger", gender: "female", personality: "Peppy" },
  "Biff": { species: "Hippo", gender: "male", personality: "Jock" },
  "Big Top": { species: "Elephant", gender: "male", personality: "Lazy" },
  "Bill": { species: "Duck", gender: "male", personality: "Jock" },
  "Billy": { species: "Goat", gender: "male", personality: "Jock" },
  "Biskit": { species: "Dog", gender: "male", personality: "Lazy" },
  "Bitty": { species: "Hippo", gender: "female", personality: "Snooty" },
  "Blaire": { species: "Squirrel", gender: "female", personality: "Snooty" },
  "Blanche": { species: "Ostrich", gender: "female", personality: "Snooty" },
  "Bluebear": { species: "Cub", gender: "female", personality: "Peppy" },
  "Bob": { species: "Cat", gender: "male", personality: "Lazy" },
  "Bonbon": { species: "Rabbit", gender: "female", personality: "Peppy" },
  "Bones": { species: "Dog", gender: "male", personality: "Lazy" },
  "Boomer": { species: "Penguin", gender: "male", personality: "Lazy" },
  "Boone": { species: "Gorilla", gender: "male", personality: "Jock" },
  "Boots": { species: "Alligator", gender: "male", personality: "Jock" },
  "Boris": { species: "Pig", gender: "male", personality: "Cranky" },
  "Boyd": { species: "Gorilla", gender: "male", personality: "Cranky" },
  "Bree": { species: "Mouse", gender: "female", personality: "Snooty" },
  "Broccolo": { species: "Mouse", gender: "male", personality: "Lazy" },
  "Broffina": { species: "Chicken", gender: "female", personality: "Snooty" },
  "Bruce": { species: "Deer", gender: "male", personality: "Cranky" },
  "Bubbles": { species: "Hippo", gender: "female", personality: "Peppy" },
  "Buck": { species: "Horse", gender: "male", personality: "Jock" },
  "Bud": { species: "Lion", gender: "male", personality: "Jock" },
  "Bunnie": { species: "Rabbit", gender: "female", personality: "Peppy" },
  "Butch": { species: "Dog", gender: "male", personality: "Cranky" },
  "Buzz": { species: "Eagle", gender: "male", personality: "Cranky" },
  "Cally": { species: "Squirrel", gender: "female", personality: "Normal" },
  "Camofrog": { species: "Frog", gender: "male", personality: "Cranky" },
  "Canberra": { species: "Koala", gender: "female", personality: "Uchi" },
  "Cephalobot": { species: "Octopus", gender: "male", personality: "Smug" },
  "Chabwick": { species: "Penguin", gender: "male", personality: "Lazy" },
  "Chai": { species: "Elephant", gender: "female", personality: "Peppy" },
  "Chelsea": { species: "Deer", gender: "female", personality: "Normal" },
  "Candi": { species: "Mouse", gender: "female", personality: "Peppy" },
  "Carmen": { species: "Rabbit", gender: "female", personality: "Peppy" },
  "Caroline": { species: "Squirrel", gender: "female", personality: "Normal" },
  "Carrie": { species: "Kangaroo", gender: "female", personality: "Normal" },
  "Cashmere": { species: "Sheep", gender: "female", personality: "Snooty" },
  "Celia": { species: "Eagle", gender: "female", personality: "Normal" },
  "Cesar": { species: "Gorilla", gender: "male", personality: "Cranky" },
  "Chadder": { species: "Mouse", gender: "male", personality: "Smug" },
  "Charlise": { species: "Bear", gender: "female", personality: "Uchi" },
  "Cheri": { species: "Cub", gender: "female", personality: "Peppy" },
  "Cherry": { species: "Dog", gender: "female", personality: "Uchi" },
  "Chester": { species: "Cub", gender: "male", personality: "Lazy" },
  "Chevre": { species: "Goat", gender: "female", personality: "Normal" },
  "Chief": { species: "Wolf", gender: "male", personality: "Cranky" },
  "Chops": { species: "Pig", gender: "male", personality: "Smug" },
  "Chow": { species: "Bear", gender: "male", personality: "Cranky" },
  "Chrissy": { species: "Rabbit", gender: "female", personality: "Peppy" },
  "Claude": { species: "Rabbit", gender: "male", personality: "Lazy" },
  "Claudia": { species: "Tiger", gender: "female", personality: "Snooty" },
  "Clay": { species: "Hamster", gender: "male", personality: "Lazy" },
  "Cleo": { species: "Horse", gender: "female", personality: "Snooty" },
  "Clyde": { species: "Horse", gender: "male", personality: "Lazy" },
  "Coach": { species: "Bull", gender: "male", personality: "Jock" },
  "Cobb": { species: "Pig", gender: "male", personality: "Jock" },
  "Coco": { species: "Rabbit", gender: "female", personality: "Normal" },
  "Cole": { species: "Rabbit", gender: "male", personality: "Lazy" },
  "Colton": { species: "Horse", gender: "male", personality: "Smug" },
  "Cookie": { species: "Dog", gender: "female", personality: "Peppy" },
  "Cousteau": { species: "Frog", gender: "male", personality: "Jock" },
  "Crackle": { species: "Pig", gender: "male", personality: "Lazy" },
  "Cranston": { species: "Ostrich", gender: "male", personality: "Lazy" },
  "Croque": { species: "Frog", gender: "male", personality: "Cranky" },
  "Cube": { species: "Penguin", gender: "male", personality: "Lazy" },
  "Curlos": { species: "Sheep", gender: "male", personality: "Smug" },
  "Curly": { species: "Pig", gender: "male", personality: "Jock" },
  "Curt": { species: "Bear", gender: "male", personality: "Cranky" },
  "Cyd": { species: "Elephant", gender: "male", personality: "Cranky" },
  "Cyrano": { species: "AntEater", gender: "male", personality: "Cranky" },
  "Daisy": { species: "Dog", gender: "female", personality: "Normal" },
  "Deena": { species: "Duck", gender: "female", personality: "Normal" },
  "Deirdre": { species: "Deer", gender: "female", personality: "Uchi" },
  "Del": { species: "Alligator", gender: "male", personality: "Cranky" },
  "Deli": { species: "Monkey", gender: "male", personality: "Lazy" },
  "Derwin": { species: "Duck", gender: "male", personality: "Lazy" },
  "Diana": { species: "Deer", gender: "female", personality: "Snooty" },
  "Diva": { species: "Frog", gender: "female", personality: "Uchi" },
  "Dizzy": { species: "Elephant", gender: "male", personality: "Lazy" },
  "Dobie": { species: "Wolf", gender: "male", personality: "Cranky" },
  "Doc": { species: "Rabbit", gender: "male", personality: "Lazy" },
  "Dom": { species: "Sheep", gender: "male", personality: "Jock" },
  "Dora": { species: "Mouse", gender: "female", personality: "Normal" },
  "Dotty": { species: "Rabbit", gender: "female", personality: "Peppy" },
  "Drago": { species: "Alligator", gender: "male", personality: "Lazy" },
  "Drake": { species: "Duck", gender: "male", personality: "Lazy" },
  "Drift": { species: "Frog", gender: "male", personality: "Jock" },
  "Ed": { species: "Horse", gender: "male", personality: "Smug" },
  "Egbert": { species: "Chicken", gender: "male", personality: "Lazy" },
  "Elise": { species: "Monkey", gender: "female", personality: "Snooty" },
  "Étoile": { species: "Sheep", gender: "female", personality: "Normal" },
  "Ellie": { species: "Elephant", gender: "female", personality: "Normal" },
  "Elmer": { species: "Horse", gender: "male", personality: "Lazy" },
  "Eloise": { species: "Elephant", gender: "female", personality: "Snooty" },
  "Elvis": { species: "Lion", gender: "male", personality: "Cranky" },
  "Erik": { species: "Deer", gender: "male", personality: "Lazy" },
  "Eugene": { species: "Koala", gender: "male", personality: "Smug" },
  "Eunice": { species: "Sheep", gender: "female", personality: "Normal" },
  "Faith": { species: "Koala", gender: "female", personality: "Uchi" },
  "Fang": { species: "Wolf", gender: "male", personality: "Cranky" },
  "Fauna": { species: "Deer", gender: "female", personality: "Normal" },
  "Felicity": { species: "Cat", gender: "female", personality: "Peppy" },
  "Filbert": { species: "Squirrel", gender: "male", personality: "Lazy" },
  "Flip": { species: "Monkey", gender: "male", personality: "Jock" },
  "Flo": { species: "Penguin", gender: "female", personality: "Uchi" },
  "Flora": { species: "Ostrich", gender: "female", personality: "Peppy" },
  "Flurry": { species: "Hamster", gender: "female", personality: "Normal" },
  "Francine": { species: "Rabbit", gender: "female", personality: "Snooty" },
  "Frank": { species: "Eagle", gender: "male", personality: "Cranky" },
  "Frett": { species: "Dog", gender: "male", personality: "Cranky" },
  "Freckles": { species: "Duck", gender: "female", personality: "Peppy" },
  "Freya": { species: "Wolf", gender: "female", personality: "Snooty" },
  "Friga": { species: "Penguin", gender: "female", personality: "Snooty" },
  "Frita": { species: "Sheep", gender: "female", personality: "Uchi" },
  "Frobert": { species: "Frog", gender: "male", personality: "Jock" },
  "Fuchsia": { species: "Deer", gender: "female", personality: "Uchi" },
  "Gabi": { species: "Rabbit", gender: "female", personality: "Peppy" },
  "Gala": { species: "Pig", gender: "female", personality: "Normal" },
  "Gaston": { species: "Rabbit", gender: "male", personality: "Cranky" },
  "Gayle": { species: "Alligator", gender: "female", personality: "Normal" },
  "Genji": { species: "Rabbit", gender: "male", personality: "Jock" },
  "Gigi": { species: "Frog", gender: "female", personality: "Snooty" },
  "Gladys": { species: "Ostrich", gender: "female", personality: "Normal" },
  "Gloria": { species: "Duck", gender: "female", personality: "Snooty" },
  "Goldie": { species: "Dog", gender: "female", personality: "Normal" },
  "Gonzo": { species: "Koala", gender: "male", personality: "Cranky" },
  "Goose": { species: "Chicken", gender: "male", personality: "Jock" },
  "Graham": { species: "Hamster", gender: "male", personality: "Smug" },
  "Greta": { species: "Mouse", gender: "female", personality: "Snooty" },
  "Grizzly": { species: "Bear", gender: "male", personality: "Cranky" },
  "Groucho": { species: "Bear", gender: "male", personality: "Cranky" },
  "Gruff": { species: "Goat", gender: "male", personality: "Cranky" },
  "Gwen": { species: "Penguin", gender: "female", personality: "Snooty" },
  "Hamlet": { species: "Hamster", gender: "male", personality: "Jock" },
  "Hamphrey": { species: "Hamster", gender: "male", personality: "Cranky" },
  "Hans": { species: "Gorilla", gender: "male", personality: "Smug" },
  "Harry": { species: "Hippo", gender: "male", personality: "Cranky" },
  "Hazel": { species: "Squirrel", gender: "female", personality: "Uchi" },
  "Henry": { species: "Frog", gender: "male", personality: "Smug" },
  "Hippeux": { species: "Hippo", gender: "male", personality: "Smug" },
  "Hopkins": { species: "Rabbit", gender: "male", personality: "Lazy" },
  "Hopper": { species: "Penguin", gender: "male", personality: "Cranky" },
  "Hornsby": { species: "Rhino", gender: "male", personality: "Lazy" },
  "Huck": { species: "Frog", gender: "male", personality: "Smug" },
  "Hugh": { species: "Pig", gender: "male", personality: "Lazy" },
  "Iggly": { species: "Penguin", gender: "male", personality: "Jock" },
  "Ike": { species: "Bear", gender: "male", personality: "Cranky" },
  "Ione": { species: "Squirrel", gender: "female", personality: "Normal" },
  "Jacob": { species: "Bird", gender: "male", personality: "Lazy" },
  "Jacques": { species: "Bird", gender: "male", personality: "Smug" },
  "Jakey": { species: "Bird", gender: "male", personality: "Lazy" },
  "Jambette": { species: "Frog", gender: "female", personality: "Normal" },
  "Jay": { species: "Bird", gender: "male", personality: "Jock" },
  "Jeremiah": { species: "Frog", gender: "male", personality: "Lazy" },
  "Jitters": { species: "Bird", gender: "male", personality: "Jock" },
  "Joey": { species: "Duck", gender: "male", personality: "Lazy" },
  "Judy": { species: "Cub", gender: "female", personality: "Snooty" },
  "Julia": { species: "Ostrich", gender: "female", personality: "Snooty" },
  "Julian": { species: "Horse", gender: "male", personality: "Smug" },
  "June": { species: "Cub", gender: "female", personality: "Normal" },
  "Kabuki": { species: "Cat", gender: "male", personality: "Cranky" },
  "Katt": { species: "Cat", gender: "female", personality: "Uchi" },
  "Keaton": { species: "Eagle", gender: "male", personality: "Smug" },
  "Ken": { species: "Chicken", gender: "male", personality: "Smug" },
  "Ketchup": { species: "Duck", gender: "female", personality: "Peppy" },
  "Kevin": { species: "Pig", gender: "male", personality: "Jock" },
  "Kid Cat": { species: "Cat", gender: "male", personality: "Jock" },
  "Kidd": { species: "Goat", gender: "male", personality: "Smug" },
  "Kiki": { species: "Cat", gender: "female", personality: "Normal" },
  "Kitt": { species: "Kangaroo", gender: "female", personality: "Normal" },
  "Kitty": { species: "Cat", gender: "female", personality: "Snooty" },
  "Klaus": { species: "Bear", gender: "male", personality: "Smug" },
  "Knox": { species: "Chicken", gender: "male", personality: "Cranky" },
  "Kody": { species: "Cub", gender: "male", personality: "Jock" },
  "Kyle": { species: "Wolf", gender: "male", personality: "Smug" },
  "Leonardo": { species: "Tiger", gender: "male", personality: "Jock" },
  "Leopold": { species: "Lion", gender: "male", personality: "Smug" },
  "Lily": { species: "Frog", gender: "female", personality: "Normal" },
  "Limberg": { species: "Mouse", gender: "male", personality: "Cranky" },
  "Lionel": { species: "Lion", gender: "male", personality: "Smug" },
  "Lobo": { species: "Wolf", gender: "male", personality: "Cranky" },
  "Lolly": { species: "Cat", gender: "female", personality: "Normal" },
  "Lopez": { species: "Deer", gender: "male", personality: "Smug" },
  "Louie": { species: "Gorilla", gender: "male", personality: "Jock" },
  "Lucha": { species: "Bird", gender: "male", personality: "Smug" },
  "Lucky": { species: "Dog", gender: "male", personality: "Lazy" },
  "Lucy": { species: "Pig", gender: "female", personality: "Normal" },
  "Lyman": { species: "Koala", gender: "male", personality: "Jock" },
  "Mac": { species: "Dog", gender: "male", personality: "Jock" },
  "Maddie": { species: "Dog", gender: "female", personality: "Peppy" },
  "Maelle": { species: "Duck", gender: "female", personality: "Snooty" },
  "Maggie": { species: "Pig", gender: "female", personality: "Normal" },
  "Mallary": { species: "Duck", gender: "female", personality: "Snooty" },
  "Maple": { species: "Cub", gender: "female", personality: "Normal" },
  "Marcel": { species: "Dog", gender: "male", personality: "Lazy" },
  "Marcie": { species: "Kangaroo", gender: "female", personality: "Normal" },
  "Margie": { species: "Elephant", gender: "female", personality: "Normal" },
  "Marina": { species: "Octopus", gender: "female", personality: "Normal" },
  "Marlo": { species: "Hamster", gender: "male", personality: "Cranky" },
  "Marshal": { species: "Squirrel", gender: "male", personality: "Smug" },
  "Marty": { species: "Cub", gender: "male", personality: "Lazy" },
  "Mathilda": { species: "Kangaroo", gender: "female", personality: "Snooty" },
  "Megan": { species: "Bear", gender: "female", personality: "Normal" },
  "Melba": { species: "Koala", gender: "female", personality: "Normal" },
  "Merengue": { species: "Rhino", gender: "female", personality: "Normal" },
  "Merry": { species: "Cat", gender: "female", personality: "Peppy" },
  "Midge": { species: "Bird", gender: "female", personality: "Normal" },
  "Mint": { species: "Squirrel", gender: "female", personality: "Snooty" },
  "Mira": { species: "Rabbit", gender: "female", personality: "Uchi" },
  "Miranda": { species: "Duck", gender: "female", personality: "Snooty" },
  "Mitzi": { species: "Cat", gender: "female", personality: "Normal" },
  "Moe": { species: "Cat", gender: "male", personality: "Lazy" },
  "Molly": { species: "Duck", gender: "female", personality: "Normal" },
  "Monique": { species: "Cat", gender: "female", personality: "Snooty" },
  "Monty": { species: "Monkey", gender: "male", personality: "Cranky" },
  "Moose": { species: "Mouse", gender: "male", personality: "Jock" },
  "Mott": { species: "Lion", gender: "male", personality: "Jock" },
  "Muffy": { species: "Sheep", gender: "female", personality: "Uchi" },
  "Murphy": { species: "Cub", gender: "male", personality: "Cranky" },
  "Nan": { species: "Goat", gender: "female", personality: "Normal" },
  "Nana": { species: "Monkey", gender: "female", personality: "Normal" },
  "Naomi": { species: "Cow", gender: "female", personality: "Snooty" },
  "Nate": { species: "Bear", gender: "male", personality: "Lazy" },
  "Nibbles": { species: "Squirrel", gender: "female", personality: "Peppy" },
  "Norma": { species: "Cow", gender: "female", personality: "Normal" },
  "O'Hare": { species: "Rabbit", gender: "male", personality: "Smug" },
  "Octavian": { species: "Octopus", gender: "male", personality: "Cranky" },
  "Olaf": { species: "AntEater", gender: "male", personality: "Smug" },
  "Olive": { species: "Cub", gender: "female", personality: "Normal" },
  "Olivia": { species: "Cat", gender: "female", personality: "Snooty" },
  "Opal": { species: "Elephant", gender: "female", personality: "Snooty" },
  "Ozzie": { species: "Koala", gender: "male", personality: "Lazy" },
  "Pancetti": { species: "Pig", gender: "female", personality: "Snooty" },
  "Pango": { species: "AntEater", gender: "female", personality: "Peppy" },
  "Paolo": { species: "Elephant", gender: "male", personality: "Lazy" },
  "Papi": { species: "Horse", gender: "male", personality: "Lazy" },
  "Pashmina": { species: "Goat", gender: "female", personality: "Uchi" },
  "Pate": { species: "Duck", gender: "female", personality: "Peppy" },
  "Patty": { species: "Cow", gender: "female", personality: "Peppy" },
  "Paula": { species: "Bear", gender: "female", personality: "Uchi" },
  "Peaches": { species: "Horse", gender: "female", personality: "Normal" },
  "Peanut": { species: "Squirrel", gender: "female", personality: "Peppy" },
  "Pecan": { species: "Squirrel", gender: "female", personality: "Snooty" },
  "Peck": { species: "Bird", gender: "male", personality: "Jock" },
  "Petri": { species: "Mouse", gender: "female", personality: "Snooty" },
  "Peewee": { species: "Gorilla", gender: "male", personality: "Cranky" },
  "Peggy": { species: "Pig", gender: "female", personality: "Peppy" },
  "Pekoe": { species: "Cub", gender: "female", personality: "Normal" },
  "Penelope": { species: "Mouse", gender: "female", personality: "Peppy" },
  "Phil": { species: "Ostrich", gender: "male", personality: "Smug" },
  "Phoebe": { species: "Ostrich", gender: "female", personality: "Uchi" },
  "Pierce": { species: "Eagle", gender: "male", personality: "Jock" },
  "Pietro": { species: "Sheep", gender: "male", personality: "Smug" },
  "Pinky": { species: "Bear", gender: "female", personality: "Peppy" },
  "Piper": { species: "Bird", gender: "female", personality: "Peppy" },
  "Pippy": { species: "Rabbit", gender: "female", personality: "Peppy" },
  "Plucky": { species: "Chicken", gender: "female", personality: "Uchi" },
  "Pompom": { species: "Duck", gender: "female", personality: "Peppy" },
  "Poncho": { species: "Cub", gender: "male", personality: "Jock" },
  "Poppy": { species: "Squirrel", gender: "female", personality: "Normal" },
  "Portia": { species: "Dog", gender: "female", personality: "Snooty" },
  "Prince": { species: "Frog", gender: "male", personality: "Lazy" },
  "Puck": { species: "Penguin", gender: "male", personality: "Lazy" },
  "Puddles": { species: "Frog", gender: "female", personality: "Peppy" },
  "Pudge": { species: "Cub", gender: "male", personality: "Lazy" },
  "Punchy": { species: "Cat", gender: "male", personality: "Lazy" },
  "Purrl": { species: "Cat", gender: "female", personality: "Snooty" },
  "Queenie": { species: "Ostrich", gender: "female", personality: "Snooty" },
  "Quillson": { species: "Duck", gender: "male", personality: "Smug" },
  "Quinn": { species: "Eagle", gender: "female", personality: "Uchi" },
  "Raddle": { species: "Frog", gender: "male", personality: "Lazy" },
  "Rasher": { species: "Pig", gender: "male", personality: "Cranky" },
  "Raymond": { species: "Cat", gender: "male", personality: "Smug" },
  "Reneigh": { species: "Horse", gender: "female", personality: "Uchi" },
  "Renée": { species: "Rhino", gender: "female", personality: "Uchi" },
  "Rex": { species: "Lion", gender: "male", personality: "Lazy" },
  "Rhonda": { species: "Rhino", gender: "female", personality: "Normal" },
  "Ribbot": { species: "Frog", gender: "male", personality: "Jock" },
  "Ricky": { species: "Squirrel", gender: "male", personality: "Cranky" },
  "Rilla": { species: "Gorilla", gender: "female", personality: "Peppy" },
  "Rio": { species: "Ostrich", gender: "female", personality: "Peppy" },
  "Rizzo": { species: "Mouse", gender: "male", personality: "Cranky" },
  "Roald": { species: "Penguin", gender: "male", personality: "Jock" },
  "Robin": { species: "Bird", gender: "female", personality: "Snooty" },
  "Rocco": { species: "Hippo", gender: "male", personality: "Cranky" },
  "Rocket": { species: "Gorilla", gender: "female", personality: "Uchi" },
  "Rod": { species: "Mouse", gender: "male", personality: "Jock" },
  "Rodeo": { species: "Bull", gender: "male", personality: "Lazy" },
  "Rodney": { species: "Hamster", gender: "male", personality: "Smug" },
  "Rolf": { species: "Tiger", gender: "male", personality: "Cranky" },
  "Rooney": { species: "Kangaroo", gender: "male", personality: "Cranky" },
  "Rory": { species: "Lion", gender: "male", personality: "Jock" },
  "Roscoe": { species: "Horse", gender: "male", personality: "Cranky" },
  "Rosie": { species: "Cat", gender: "female", personality: "Peppy" },
  "Rowan": { species: "Tiger", gender: "male", personality: "Jock" },
  "Ruby": { species: "Rabbit", gender: "female", personality: "Peppy" },
  "Rudy": { species: "Cat", gender: "male", personality: "Jock" },
  "Sally": { species: "Squirrel", gender: "female", personality: "Normal" },
  "Samson": { species: "Mouse", gender: "male", personality: "Jock" },
  "Sandy": { species: "Ostrich", gender: "female", personality: "Normal" },
  "Sasha": { species: "Rabbit", gender: "male", personality: "Lazy" },
  "Savannah": { species: "Horse", gender: "female", personality: "Normal" },
  "Scoot": { species: "Duck", gender: "male", personality: "Jock" },
  "Shari": { species: "Monkey", gender: "female", personality: "Uchi" },
  "Sheldon": { species: "Squirrel", gender: "male", personality: "Jock" },
  "Shep": { species: "Dog", gender: "male", personality: "Smug" },
  "Sherb": { species: "Goat", gender: "male", personality: "Lazy" },
  "Shino": { species: "Deer", gender: "female", personality: "Peppy" },
  "Simon": { species: "Monkey", gender: "male", personality: "Lazy" },
  "Skye": { species: "Wolf", gender: "female", personality: "Normal" },
  "Sly": { species: "Alligator", gender: "male", personality: "Jock" },
  "Snake": { species: "Rabbit", gender: "male", personality: "Jock" },
  "Snooty": { species: "AntEater", gender: "female", personality: "Snooty" },
  "Soleil": { species: "Hamster", gender: "female", personality: "Snooty" },
  "Sparro": { species: "Bird", gender: "male", personality: "Jock" },
  "Spike": { species: "Rhino", gender: "male", personality: "Cranky" },
  "Sprinkle": { species: "Penguin", gender: "female", personality: "Peppy" },
  "Spork": { species: "Pig", gender: "male", personality: "Lazy" },
  "Sprocket": { species: "Ostrich", gender: "male", personality: "Jock" },
  "Static": { species: "Squirrel", gender: "male", personality: "Cranky" },
  "Stella": { species: "Sheep", gender: "female", personality: "Normal" },
  "Sterling": { species: "Eagle", gender: "male", personality: "Jock" },
  "Stinky": { species: "Cat", gender: "male", personality: "Jock" },
  "Stitches": { species: "Cub", gender: "male", personality: "Lazy" },
  "Stu": { species: "Bull", gender: "male", personality: "Lazy" },
  "Sydney": { species: "Koala", gender: "female", personality: "Normal" },
  "Sylvana": { species: "Squirrel", gender: "female", personality: "Normal" },
  "Sylvia": { species: "Kangaroo", gender: "female", personality: "Uchi" },
  "T-Bone": { species: "Bull", gender: "male", personality: "Cranky" },
  "Tabby": { species: "Cat", gender: "female", personality: "Peppy" },
  "Tad": { species: "Frog", gender: "male", personality: "Jock" },
  "Tammi": { species: "Monkey", gender: "female", personality: "Peppy" },
  "Tammy": { species: "Cub", gender: "female", personality: "Uchi" },
  "Tangy": { species: "Cat", gender: "female", personality: "Peppy" },
  "Tank": { species: "Rhino", gender: "male", personality: "Jock" },
  "Tasha": { species: "Squirrel", gender: "female", personality: "Snooty" },
  "Teddy": { species: "Bear", gender: "male", personality: "Jock" },
  "Tex": { species: "Penguin", gender: "male", personality: "Smug" },
  "Tiansheng": { species: "Monkey", gender: "male", personality: "Jock" },
  "Tia": { species: "Elephant", gender: "female", personality: "Normal" },
  "Tiffany": { species: "Rabbit", gender: "female", personality: "Snooty" },
  "Toby": { species: "Rabbit", gender: "male", personality: "Smug" },
  "Timbra": { species: "Sheep", gender: "female", personality: "Snooty" },
  "Tipper": { species: "Cow", gender: "female", personality: "Snooty" },
  "Tom": { species: "Cat", gender: "male", personality: "Cranky" },
  "Truffles": { species: "Pig", gender: "female", personality: "Peppy" },
  "Tucker": { species: "Elephant", gender: "male", personality: "Lazy" },
  "Tutu": { species: "Bear", gender: "female", personality: "Peppy" },
  "Twiggy": { species: "Bird", gender: "female", personality: "Peppy" },
  "Tybalt": { species: "Tiger", gender: "male", personality: "Jock" },
  "Ursala": { species: "Bear", gender: "female", personality: "Uchi" },
  "Velma": { species: "Goat", gender: "female", personality: "Snooty" },
  "Vesta": { species: "Sheep", gender: "female", personality: "Normal" },
  "Vic": { species: "Bull", gender: "male", personality: "Cranky" },
  "Victoria": { species: "Horse", gender: "female", personality: "Peppy" },
  "Violet": { species: "Gorilla", gender: "female", personality: "Snooty" },
  "Vivian": { species: "Wolf", gender: "female", personality: "Snooty" },
  "Vladimir": { species: "Cub", gender: "male", personality: "Cranky" },
  "Wade": { species: "Penguin", gender: "male", personality: "Lazy" },
  "Walker": { species: "Dog", gender: "male", personality: "Lazy" },
  "Walt": { species: "Kangaroo", gender: "male", personality: "Cranky" },
  "Wart Jr.": { species: "Frog", gender: "male", personality: "Cranky" },
  "Weber": { species: "Duck", gender: "male", personality: "Lazy" },
  "Wendy": { species: "Sheep", gender: "female", personality: "Peppy" },
  "Whitney": { species: "Wolf", gender: "female", personality: "Snooty" },
  "Willow": { species: "Sheep", gender: "female", personality: "Snooty" },
  "Winnie": { species: "Horse", gender: "female", personality: "Peppy" },
  "Wolfgang": { species: "Wolf", gender: "male", personality: "Cranky" },
  "Yuka": { species: "Koala", gender: "female", personality: "Snooty" },
  "Zell": { species: "Deer", gender: "male", personality: "Smug" },
  "Zoe": { species: "Anteater", gender: "female", personality: "Normal" },
  "Zucker": { species: "Octopus", gender: "male", personality: "Lazy" }
};
// Add default data for all other villagers
export const getDefaultVillagerData = (name) => ({
  species: "Unknown",
  gender: "unknown", 
  personality: "Unknown"
});

export const SPECIES_ICONS = {
  "Alligator": "🐊",
  "AntEater": "🦔",
  "Bear": "🐻",
  "Bird": "🐦‍⬛",
  "Bull": "🐂",
  "Cat": "🐱",
  "Chicken": "🐔",
  "Cow": "🐄",
  "Cub": "🧸",
  "Deer": "🦌",
  "Dog": "🐶",
  "Duck": "🦆",
  "Eagle": "🦅",
  "Elephant": "🐘",
  "Frog": "🐸",
  "Goat": "🐐",
  "Gorilla": "🦍",
  "Hamster": "🐹",
  "Hippo": "🦛",
  "Horse": "🐴",
  "Kangaroo": "🦘",
  "Koala": "🐨",
  "Lion": "🦁",
  "Monkey": "🐵",
  "Mouse": "🐭",
  "Octopus": "🐙",
  "Ostrich": "🦃",
  "Penguin": "🐧",
  "Pig": "🐷",
  "Rabbit": "🐰",
  "Rhino": "🦏",
  "Sheep": "🐑",
  "Squirrel": "🐿️",
  "Tiger": "🐯",
  "Wolf": "🐺"
};

export const PERSONALITY_ICONS = {
  "Snooty": "💎",
  "Uchi": "💪",
  "Peppy": "⭐",
  "Normal": "🌸",
  "Cranky": "😤",
  "Lazy": "😴",
  "Jock": "🏃",
  "Smug": "😎"
};

export const GENDER_ICONS = {
  "male": "♂️",
  "female": "♀️"
};
